var api = "https://api.qingcigame.com";

function pop(name, isLogin) {
    $("#cover").show();
    $("#" + name).show();
    if (isLogin) {
        islogin = true;
        $("#submit").hide();
    } else {
        islogin = false;
        $("#login").hide();
    }
}

function closePop(name) {
    $("#cover").hide();

    $(".submit .btnCover").hide();
    $("#submit,#login").show();

    $("input").val("");
    if (!name) {
        $(".pop").hide();
        return;
    }
    $("#" + name).show();
}

$(function() {
    $("#top .title").append(
        '<a class="monitor-btn" href="https://apps.apple.com/jp/app/%E3%82%AB%E3%83%BC%E3%83%89%E3%82%AD%E3%83%A3%E3%83%97%E3%82%BF%E3%83%BC%E3%81%95%E3%81%8F%E3%82%89-%E6%80%9D%E3%81%84%E5%87%BA%E3%81%AE%E9%8D%B5/id6754003671" id="btn" data-event="to_download"></a>',
    );

    $(".monitor-btn").on("click", function() {
        var mon_btn = $(this).attr("data-event");
        countNum(mon_btn);
    });
    // 阿里云埋点
    function countNum(data) {
        setTimeout(() => {
            try {
                __bl.sum(data);
            } catch (e) {
                console.log(e);
            }
        }, 500);
    }

    var isMac = /macintosh|mac os x/i.test(navigator.userAgent);

    // 当前时间戳
    var newTime = new Date().getTime();
    // 游戏上线时间戳
    var onlineTime = new Date("2026/6/25").getTime();
    if (newTime > onlineTime) {
        $("#btn").remove();
        $("#top .title").append('<a href="javascript:void(0)" id="end_btn"></a>');
    }

    var musicHowl = new Howl({
        src: ["/pre-registration/images/music.mp3"],
        autoplay: true,
        loop: true,
        onplay: function() {},
    });
    musicHowl.play();
    var musicCount = 0;
    $(".music").click(function() {
        if (musicCount == 0) {
            musicHowl.stop();
            musicCount = 1;
            $(".music").css({
                background: "url('/pre-registration/images/mobile/btn1-cb2f9e18ec.png') top no-repeat",
                backgroundSize: "cover",
            });
        } else {
            musicHowl.play();
            musicCount = 0;
            $(".music").css({
                background: "url('/pre-registration/images/mobile/btn-d16a5c3536.png') center no-repeat",
                backgroundSize: "cover",
            });
        }
    });

    $("#cover").click(function() {
        closePop();
    });

    // 根据机型去平台
    $(".to_subscribe").click(function() {
        closePop();
        if (isMac) {
            window.open(
                "https://apps.apple.com/jp/app/%E3%82%AB%E3%83%BC%E3%83%89%E3%82%AD%E3%83%A3%E3%83%97%E3%82%BF%E3%83%BC%E3%81%95%E3%81%8F%E3%82%89-%E6%80%9D%E3%81%84%E5%87%BA%E3%81%AE%E9%8D%B5/id6754003671",
            );
        } else {
            window.open(
                "https://play.google.com/store/apps/details?id=com.karaq.sakura.jp",
            );
        }
    });

    var swiperIndex = 0;
    var swiper = new Swiper(".swiper-container", {
        direction: "vertical",
        slidesPerView: "auto",
        spaceBetween: 0,
        mousewheelControl: true,
        resistanceRatio: 0,
        touchStartPreventDefault: false,
        onSlideChangeStart: function(swiper) {
            if ($(".fb-page span").width() && $(".fb-page span").width() > 1) {
                $(".no_fb").hide();
                $(".title2").show();
            } else {
                $(".no_fb").show();
                $(".title2").hide();
            }
            if (swiperIndex == 0) {
                $("#menu .wrap1 div").attr("class", "home");
            } else if (swiperIndex == 1) {
                $("#menu .wrap3 div").attr("class", "booking-bonus");
            } else if (swiperIndex == 2) {
                $("#menu .wrap5 div").attr("class", "characters-intro");
            } else if (swiperIndex == 3) {
                $("#menu .wrap6 div").attr("class", "game-features");
            }
            swiperIndex = swiper.activeIndex;
            if (swiper.activeIndex == 0) {
                $(".content_03_title,.content_05_title,.content_06_title").removeClass(
                    "width_ani",
                );
                $("#menu .wrap1 div").attr("class", "home-1");
            } else if (swiper.activeIndex == 1) {
                $(".content_03_title").addClass("width_ani");
                $(".content_05_title,.content_06_title").removeClass("width_ani");
                $("#menu .wrap3 div").attr("class", "booking-bonus-1");
            } else if (swiper.activeIndex == 2) {
                $(".content_05_title").addClass("width_ani");
                $(".content_03_title,.content_06_title").removeClass("width_ani");
                $("#menu .wrap5 div").attr("class", "characters-intro-1");
            } else if (swiper.activeIndex == 3) {
                $(".content_06_title").addClass("width_ani");
                $(".content_03_title,.content_05_title").removeClass("width_ani");
                $("#menu .wrap6 div").attr("class", "game-features-1");
            }
        },
    });
    var cardSwiper = new Swiper(".swiper-container-card", {
        direction: "horizontal",
        loop: true,
        pagination: ".swiper-pagination",
        paginationClickable: true,
        effect: "coverflow",
        centeredSlides: true,
        slideToClickedSlide: true,
        slidesPerView: "auto",
        coverflow: {
            rotate: 0, // 旋转的角度
            stretch: 800, // 拉伸   图片间左右的间距和密集度
            depth: 140, // 深度   切换图片间上下的间距和密集度
            // modifier: 10, // 修正值 该值越大前面的效果越明显
            slideShadows: false, // 页面阴影效果
        },
    });
    $(".fb_btn").click(function() {
        window.open(
            "https://www.facebook.com/ccsakuragame/posts/pfbid0Bh6v6MMD8McnSMY4y7YyxU5cs9YbzDiYt8aePVnSZ5Y7Mf1aQjWia17J7PdpitJ7l",
        );
    });

    $("#menu .wrap1").click(function() {
        swiper.slideTo(0, 500, true);
    });

    $("#menu .wrap3").click(function() {
        swiper.slideTo(1, 500, true);
    });

    $("#menu .wrap5").click(function() {
        swiper.slideTo(2, 500, true);
    });

    $("#menu .wrap6").click(function() {
        swiper.slideTo(3, 500, true);
    });

    share();

    function share() {
        var share_icon =
            "https://download4.qcplay.com/qcgame-admin/5Voo6wjspOhsom8VFeSWJoi08UZNesGlnkrPbgQt.png";
        var share_big_title = "《庫洛魔法使 回憶鑰匙》手遊預約活動開啟";
        var share_min_title = "快來和我一起籌備上線甜品派對吧~";
        var share_link = window.location.href;
        outside.share(share_icon, share_big_title, share_min_title, share_link);
    }

    $(".cancel_btn, .close-bg").click(function() {
        closePop();
    });

    // 打开预约奖励活动弹窗
    $(".booking_bonus .btn, .gift2_btn").click(function() {
        pop("booking_bonus_dialog");
    });

    // 关闭预约奖励活动弹窗
    $("#booking_bonus_dialog .close_btn").click(function() {
        closePop();
    });

    // 去X社交群
    $(".to_X").click(function() {
        window.open("https://x.com/ccsakuraomokagi");
    });

    // 去Instagram社交群
    $(".to_instagram").click(function() {
        window.open("https://www.instagram.com/ccsakura_omokagi/");
    });

    // 去line社交群
    $(".to_line").click(function() {
        window.open("https://lin.ee/5tOEM8F");
    });

    // 去TikTok社交群
    $(".to_TikTok").click(function() {
        window.open("https://www.tiktok.com/@ccsakura_omokagi");
    });

    // 去YouTube社交群
    $(".to_YouTube").click(function() {
        window.open("https://www.youtube.com/@ccsakura_omokagi");
    });

    // 去Discord社交群
    $(".to_Discord").click(function() {
        window.open("https://discord.com/invite/bzfg6XEfPK");
    });

    //获取查询字符串
    function getQueryString() {
        var queryObj = {};
        var qString = window.location.href.split("?")[1];
        //undefined
        if (!qString) {
            return queryObj;
        }
        qString = qString.indexOf("#") == -1 ? qString : qString.split("#")[0];
        if (!qString) {
            return queryObj;
        }
        var qStringArr = qString.split("&");
        for (var i = 0; i < qStringArr.length; i++) {
            var key = qStringArr[i].split("=")[0];
            var value = qStringArr[i].split("=")[1];
            queryObj[key] = value;
        }
        return queryObj;
    }

    numInit();

    function numInit() {
        $.ajax({
            url: "//api2.qcplay.com/travel/book/num",
            type: "GET",
            xhrFields: { withCredentials: true },
            data: {
                game_id: 131,
            },
            success: function(json) {
                if (json.code != 200) {
                    layer.msg(json.message);
                    return;
                } else {
                    var book_num = json.data.book_num;
                    $(".content-03 .num span").text(book_num);
                    if (book_num >= 50000 && book_num < 100000) {
                        $(".reach1").show();
                    } else if (book_num >= 100000 && book_num < 200000) {
                        $(".reach1, .reach2").show();
                    } else if (book_num >= 200000 && book_num < 300000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/pc/third/consummation-ceremony2-b07dd2a54e.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3").show();
                    } else if (book_num >= 300000 && book_num < 410000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/pc/third/consummation-ceremony3-89f08eeb64.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3, .reach4").show();
                    } else if (book_num >= 410000 && book_num < 500000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/pc/third/consummation-ceremony4-48a6dffa04.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3, .reach4, .reach5").show();
                    } else if (book_num >= 500000) {
                        $(".consummation-ceremony").css({
                            background: "url('/pre-registration/images/pc/third/consummation-ceremony5-653f18a0cf.png') no-repeat",
                            backgroundSize: "cover",
                        });
                        $(".reach1, .reach2, .reach3, .reach4, .reach5, .reach6").show();
                    }
                }
            },
            complete: function() {
                layer.close();
            },
        });
    }

    function resize() {
        var dom = document.documentElement;
        var ww = dom.clientWidth;
        var wh = dom.clientHeight;
        if (wh < 731) {
            wh = 731;
        }
        if (ww < 1300) {
            ww = 1300;
        }

        dom.style.fontSize = ww / 19.2 + "px";
        if (ww / wh >= 960 / 540) {
            // 长
            $("#bg").css({
                width: ww + "px",
            });
        } else {
            $("#bg").css({
                width: (wh * 960) / 540 + "px",
            });
        }
    }

    window.onresize = function() {
        resize();
    };

    if (cw < 1300) {
        cw = 1300;
    }
    var cw = document.documentElement.clientWidth;
    var loadingW = 0;
    loadingW = Number((8.22 * (cw / 19.2)).toFixed(2));
    var OInner = $(".process-inner");
    var OPercent = $("#percent");
    var timer2;
    var w0 = 0;
    timer2 = setInterval(function() {
        OInner.width((w0 += 2));
        OPercent.text(parseInt((w0 * 100) / loadingW));
        if (parseInt((w0 * 100) / loadingW) >= 100) {
            OPercent.text(100);
            clearInterval(timer2);
        }
        cw = document.documentElement.clientWidth;
        loadingW = (8.22 * (cw / 19.2)).toFixed(2);
        if (w0 >= loadingW) {
            clearInterval(timer2);
            $("#loading").fadeOut(300, function() {
                $("#loading").remove();
                $("#bg")[0].play();
            });
        }
    }, 5);

    $("#menu .item").click(function() {
        $("#menu .item").removeClass("a");
        $(this).addClass("a");
    });

    if (cw < 1300) cw = 1300;
});